/**
 * JSON-LD structured data for SEO/GEO.
 * Rendered on the homepage only.
 */
const ORGANIZATION = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://www.equiply.fr/#organization",
  name: "Equiply",
  alternateName: "Equiply — Logiciel de planning IDCC 1505",
  url: "https://www.equiply.fr",
  logo: "https://www.equiply.fr/logo.webp",
  description:
    "Editeur français indépendant de logiciel de planning, paie et registre du personnel pour les franchisés et magasins de proximité du commerce de détail alimentaire (convention collective IDCC 1505).",
  knowsAbout: [
    "Convention collective IDCC 1505",
    "Commerce de détail alimentaire non spécialisé",
    "Planning des équipes",
    "Registre du personnel",
    "Export paie",
    "Code du travail français",
    "Franchise alimentaire de proximité",
  ],
  areaServed: { "@type": "Country", name: "France" },
  contactPoint: {
    "@type": "ContactPoint",
    email: "contact@equiply.fr",
    contactType: "customer service",
    availableLanguage: "French",
    areaServed: "FR",
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "46 Rue du Vercors",
    addressLocality: "Montpellier",
    postalCode: "34070",
    addressCountry: "FR",
  },
};

const WEBSITE = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://www.equiply.fr/#website",
  url: "https://www.equiply.fr/",
  name: "Equiply",
  inLanguage: "fr-FR",
  publisher: { "@id": "https://www.equiply.fr/#organization" },
};

const SOFTWARE_APPLICATION = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": "https://www.equiply.fr/#software",
  name: "Equiply",
  applicationCategory: "BusinessApplication",
  applicationSubCategory: "Workforce Management Software",
  operatingSystem: "Web, iOS, Android (web app)",
  inLanguage: "fr-FR",
  countriesSupported: "FR",
  url: "https://www.equiply.fr/",
  publisher: { "@id": "https://www.equiply.fr/#organization" },
  description:
    "Logiciel de planning, gestion RH et export paie pour gérants de supérettes, franchises Carrefour Express / City / Contact, épiceries et magasins de proximité. Conforme à la convention collective IDCC 1505 et au Code du travail français.",
  audience: {
    "@type": "BusinessAudience",
    audienceType:
      "Gérants de supérettes, franchisés du commerce de détail alimentaire de proximité (IDCC 1505)",
  },
  offers: {
    "@type": "Offer",
    price: "4",
    priceCurrency: "EUR",
    priceSpecification: {
      "@type": "UnitPriceSpecification",
      price: "4",
      priceCurrency: "EUR",
      unitText: "MONTH",
      referenceQuantity: { "@type": "QuantitativeValue", value: 1 },
    },
    description: "4€ HT/mois fixe + 1€ HT/mois par salarié",
    eligibleRegion: { "@type": "Country", name: "France" },
  },
  featureList: [
    "Création de planning hebdomadaire en 5 minutes",
    "Conformité automatique à la convention collective IDCC 1505",
    "Alertes temps de repos, amplitude horaire et heures supplémentaires",
    "Registre du personnel obligatoire conforme au Code du travail",
    "Export paie automatisé (PDF / Excel) pour comptable",
    "Signature électronique des plannings et avenants",
    "Portail salarié mobile (consultation planning, demandes de congés, justificatifs)",
    "Gestion des absences, congés et indisponibilités",
    "Multi-magasins et multi-sites pour franchisés",
    "Suivi des heures complémentaires temps partiel",
  ],
};

const FAQ_DATA = [
  {
    question: "Comment fonctionne l'essai gratuit ?",
    answer:
      "Vous bénéficiez de 14 jours d'accès complet à toutes les fonctionnalités d'Equiply, sans engagement et sans carte bancaire requise. À la fin de l'essai, vous pouvez choisir de continuer avec un abonnement ou arrêter sans frais.",
  },
  {
    question: "Equiply est-il adapté aux franchisés Carrefour Express, City et Contact ?",
    answer:
      "Oui. Equiply a été conçu spécifiquement pour les gérants de magasins de proximité franchisés relevant de la convention collective IDCC 1505 — Carrefour Express, Carrefour City, Carrefour Contact, supérettes indépendantes, épiceries et commerces alimentaires de moins de 11 salariés. Toutes les règles conventionnelles (heures supplémentaires, repos dominical, temps partiel 24h, modulation) sont automatiquement appliquées.",
  },
  {
    question: "Puis-je gérer plusieurs magasins ?",
    answer:
      "Oui ! Vous pouvez gérer plusieurs magasins depuis un seul compte. Affectez des salariés à différents points de vente et gardez une vue consolidée de tous vos plannings.",
  },
  {
    question: "Comment fonctionne l'export comptable ?",
    answer:
      "Equiply génère automatiquement des rapports mensuels détaillés incluant : heures travaillées, heures supplémentaires, heures de nuit, jours fériés, congés et absences. Ces rapports sont exportables en PDF ou Excel pour votre comptable.",
  },
  {
    question: "Mes salariés peuvent-ils accéder au planning ?",
    answer:
      "Absolument ! Chaque salarié dispose de son propre accès pour consulter le planning du magasin, faire des demandes de congés et déposer des justificatifs d'absence. Ils reçoivent des notifications par email pour les nouveaux plannings.",
  },
  {
    question: "Le registre du personnel est-il conforme à la législation ?",
    answer:
      "Oui, notre registre du personnel respecte les mentions obligatoires du Code du travail français : informations personnelles, contrat, dates d'entrée/sortie, mentions spéciales pour les CDD, intérimaires, apprentis et travailleurs étrangers. Une section dédiée aux stagiaires est également disponible.",
  },
  {
    question: "Comment fonctionne le support ?",
    answer:
      "Le support email prioritaire est inclus pour tous les utilisateurs. Notre équipe répond sous 24h en jours ouvrés.",
  },
  {
    question: "Combien ça coûte ?",
    answer:
      "Equiply coûte 4€ HT/mois + 1€ HT/mois par salarié. Toutes les fonctionnalités sont incluses, pas de plans compliqués. Par exemple, pour 10 salariés : 14€ HT/mois. Vous bénéficiez de 14 jours d'essai gratuit sans carte bancaire.",
  },
  {
    question: "Puis-je annuler mon abonnement à tout moment ?",
    answer:
      "Oui, sans aucun engagement. Vous pouvez annuler votre abonnement à tout moment depuis votre espace client. Vos données restent accessibles en lecture seule pendant 30 jours après l'annulation.",
  },
];

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_DATA.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};

const SeoJsonLd = () => (
  <>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(ORGANIZATION),
      }}
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(WEBSITE),
      }}
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(SOFTWARE_APPLICATION),
      }}
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(FAQ_SCHEMA),
      }}
    />
  </>
);

export default SeoJsonLd;
